module.exports = __webpack_public_path__ + "@/assets/img/folder.05abdbd2.svg";